module.exports = __webpack_public_path__ + "media/images/cureus_logo_green-23e983d561e7883eafe9ba17c421e138.png";